import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@material-ui/core";
import { Avatar } from "@progress/kendo-react-layout";
import { SimpleLoading, HeaderHLPure, ButtonHLPure, PasswordInputPure, InputHLPure } from "../../pures";
import "./profile.css";
import "./tooltip.css";
import { Dialog } from "@progress/kendo-react-dialogs";

const ChangePasswordDialog = (props) => {
  const { t, errorMessage, onSubmit, onClose, setErrorMessage } = props;
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")

  const handleSubmit = async () => {
    await onSubmit(password, confirmPassword)
    setPassword("")
    setConfirmPassword("")
  }

  return <Dialog
    title={t("profile.title")}
    onClose={onClose}
  >
    <div className="profile-dialog">
      {errorMessage && <span className="hint-message-error">{errorMessage}</span>}

      <PasswordInputPure
        t={t}
        label={t("profile.newPassword")}
        showTooltip
        id="changePassword"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onFocus={() => setErrorMessage()}
      />

      <PasswordInputPure
        t={t}
        label={t("profile.confirmPassword")}
        id="changePasswordConfirm"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        onFocus={() => setErrorMessage()}
      />

      <ButtonHLPure
        primary
        nameBtn={t("profile.changePasswordButton")}
        onClick={handleSubmit}
      />
    </div>
  </Dialog>
}

const ChangePhoneDialog = (props) => {
  const { t, errorMessage, onSubmit, onClose, setErrorMessage } = props;
  const [phone, setPhone] = useState("")

  const handleSubmit = () => onSubmit(phone)

  return <Dialog
    title={t("profile.titlePhone")}
    onClose={onClose}
  >
    <div className="profile-dialog">
      {errorMessage && <span className="hint-message-error">{errorMessage}</span>}

      <InputHLPure
        labelInput={t("profile.updatePhoneNumber")}
        valueInput={phone}
        handleChangeInput={(e) => setPhone(e.target.value)}
        onFocus={() => setErrorMessage()}
      />

      <ButtonHLPure
        primary
        nameBtn={t("profile.changePasswordButton")}
        onClick={handleSubmit}
      />
    </div>
  </Dialog>
}

/**
 * @description user profile view page, all user profile information is displayed and can be modified here
 * @status no delete
 * @param {*} props
 * @return {*} 
 */
const ProfileView = (props) => {
  const { t, ready } = useTranslation("profile");

  if (props.loading || !ready) {
    return <div className="loading">
      <SimpleLoading />
    </div>
  }

  return (
    <>
      {
        props.showPasswordDialog && <ChangePasswordDialog
          t={t}
          errorMessage={props.passwordErrorMessage}
          onSubmit={props.onSubmitChangeUserPassword}
          onClose={props.togglePasswordDialog}
          setErrorMessage={props.setPasswordErrorMessage}
        />
      }
      {
        props.showPhoneDialog && <ChangePhoneDialog
          t={t}
          errorMessage={props.phoneErrorMessage}
          onSubmit={props.onSubmitUpdatePhoneNumber}
          onClose={props.togglePhoneDialog}
          setErrorMessage={props.setPhoneErrorMessage}
        />
      }
      <Container className="view-container">
        <Grid container spacing={3}>
          {/* Container title profile */}
          <Grid item xs={12}>
            <HeaderHLPure title={t("profile.titleProfile")} />
          </Grid>

          <Grid item xs={12}>
            <Container maxWidth={"md"}>
              <Grid container spacing={3}>
                {/* Container profile image */}
                <Grid item xs={12} >
                  <Grid container className="profileView-user" spacing={2}>
                    <Grid item xs={12} sm={2}>
                      <Avatar
                        shape="circle"
                        type="image"
                        className="profile-container-img"
                      >
                        <img
                          src={props.userPathImage}
                          alt="user image"
                          className="k-avatar-image"
                        />
                      </Avatar>
                    </Grid>

                    {/* Container profile avatar information */}
                    <Grid item xs={12} sm={10} className="profile-avatar-data">
                      <p className="profile-avatar-name">{props.userFullName || ""}</p>
                      <p className="profile-avatar-email">{props.userMail || ""}</p>
                      <ButtonHLPure
                        colorScheme="text"
                        nameBtn={t("profile.information.changePassword")}
                        onClick={props.togglePasswordDialog}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} className="profileView-user-details">
                  <dl>
                    <dt className="eticket-form-label">{t("profile.information.name")}</dt>
                    <dd>{props.firstName}</dd>

                    <dt className="eticket-form-label">{t("profile.information.firstLastName")}</dt>
                    <dd>{props.firstLastName}</dd>

                    <dt className="eticket-form-label">{t("profile.information.secondLastName")}</dt>
                    <dd>{props.secondLastName}</dd>
                  </dl>

                  <dl>
                    <dt className="eticket-form-label">{t("profile.information.email")}</dt>
                    <dd>{props.userMail}</dd>

                    <dt className="eticket-form-label">{t("profile.information.rfc")}</dt>
                    <dd>{props.rfc}</dd>

                    <dt className="eticket-form-label">{t("profile.information.phone")}</dt>
                    <dd className="profileView-user-phone"><span>{props.userPhone}</span> <button title={t("profile.titlePhone")} onClick={props.togglePhoneDialog}><i className="k-icon k-font-icon k-i-edit"></i></button></dd>
                  </dl>
                </Grid>
              </Grid>
            </Container>
          </Grid >
        </Grid >
      </Container >
    </>
  );
};
export { ProfileView as default };
